import { withStyles, WithStyles, withTheme } from "@material-ui/core";
import { FormControlLabel, FormGroup } from "@material-ui/core";
import { WithTheme } from "@material-ui/core";
import Switch, { SwitchProps } from "@material-ui/core/Switch";
import { Component } from "react";
import * as React from "react";

interface IStyles {
  bar: {};
  icon: {};
  root: {};
}

interface IProps extends SwitchProps {
  label: string;
  checked?: boolean;
  disabled?: boolean;
  value: string;
  onChange?(): void;
}

const decorate = withStyles(theme => ({
  bar: {
    backgroundColor: "#d6d6d6",
    borderRadius: 12.5,
    height: 20
  },
  icon: {
    height: 18,
    width: 18,
    marginTop: 6,
    boxShadow: "none",
    backgroundColor: "#ffffff"
  },
  root: {
    marginTop: "-5px"
  }
}));

export class MaterialSwitchUnstyled extends Component<
  IProps & WithTheme & WithStyles<keyof IStyles>
> {
  public render() {
    const { classes, checked, disabled, label, value } = this.props;

    return (
      <FormGroup>
        <FormControlLabel
          control={
            <Switch
              classes={classes}
              checked={checked}
              onChange={this.props.onChange}
            />
          }
          label={label}
          data-tip="Manage master formulary groups"
          data-for="manage-master"
          disabled={disabled}
          value={value}
        />
      </FormGroup>
    );
  }
}

export const MaterialSwitch = withTheme()(decorate(MaterialSwitchUnstyled));



// WEBPACK FOOTER //
// ./src/modules/admin/modules/UsersAdmin/switch/switch.tsx